import type { ReactNode } from 'react';
import { X } from 'lucide-react';
import '@styles/components/modal.css';

type ModalProps = {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  className?: string;
  priority?: boolean;
  /** Render a visible close (X) button in the top-right of the panel. */
  showClose?: boolean;
  /** Accessible label for the close button. */
  closeLabel?: string;
};

export default function Modal({
  open,
  onClose,
  children,
  className = '',
  priority = false,
  showClose = false,
  closeLabel = 'Close',
}: ModalProps) {
  if (!open) return null;

  return (
    <div
      className={`modal-overlay ${priority ? 'modal-priority' : ''}`}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className={`${className} ${showClose ? 'has-modal-close' : ''}`.trim()}
        onClick={(e) => e.stopPropagation()}
      >
        {showClose && (
          <button
            type="button"
            className="modal-close"
            onClick={onClose}
            aria-label={closeLabel}
          >
            <X size={18} />
          </button>
        )}
        {children}
      </div>
    </div>
  );
}
